import emailValidator from '../../../utils/Validate';
// import {EmptyObject} from 'react-hook-form';

export const validate = (values: any): any => {
  const errors: any = {};
  if (!values.email || !values.email.replace(/\s/g, '').length) {
    errors.email = 'Please enter username!';
  } else if (!values.password || !values.password.replace(/\s/g, '').length) {
    errors.password = 'Please enter password';
  } else if (
    !values.confirmPassword ||
    !values.confirmPassword.replace(/\s/g, '').length
  ) {
    errors.confirmPassword = 'Please enter confirmed password';
  }
  return errors;
};

export const validateHookForm = (values: any): any => {
  const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const errors = [];
  if (
    !values.email ||
    !values.email.replace(/\s/g, '').length ||
    pattern.test(String(values.email).toLowerCase()) === false
  ) {
    errors.push({
      name: 'email',
      type: '',
      message: 'Please enter valid email!'
    });
  }
  return errors;
};

// Latest one - Oct 2020
export const validateWithHookForm = (values: {email: string}): any => {
  let errors = {};
  if (!values.email || !values.email.replace(/\s/g, '').length) {
    errors = {email: {message: 'VALIDATORS.EMAIL_REQ'}};
  } else if (!emailValidator(String(values.email).toLowerCase())) {
    errors = {email: {message: 'VALIDATORS.INVALID_EMAIL'}};
  }
  return errors;
};
